import { FormGroup } from "../../../components/form";
import * as yup from "yup";

export const assignStatusPrimaryOptions: { label: string; value: string }[] = [
  {
    label: "Application",
    value: "Application",
  },
  {
    label: "Assessment",
    value: "Assessment",
  },
  {
    label: "QA",
    value: "QA",
  },
  {
    label: "Finalised",
    value: "Finalised",
  },
];

export const assignStatusForm: FormGroup = {
  type: "formGroup",
  fields: [
    {
      type: "field",
      key: "status",
      fieldType: "dropdown",
      label: "Assign Status",
      props: {
        options: assignStatusPrimaryOptions,
      },
      validation: yup.string().trim().required("A response is required"),
    },

    {
      type: "field",
      key: "description",
      fieldType: "dropdown",
      label: "Status Description",
      expressionProps: {
        options: (formContext, values, model) => {
          return assignStatusSecondaryOptions[model.status] ?? [];
        },
      },
      validation: yup.string().trim().required("A response is required"),
    },
  ],
};

export const assignStatusSecondaryOptions: { [key: string]: { label: string; value: string }[] } = {
  Application: [
    {
      label: "Received / awaiting check",
      value: "Received / awaiting check",
    },
    {
      label: "Initial review in progress",
      value: "Initial review in progress",
    },
    {
      label: "Add Info requested",
      value: "Add Info requested",
    },
    {
      label: "Add Info first reminder sent",
      value: "Add Info first reminder sent",
    },
    {
      label: "Add Info second reminder sent",
      value: "Add Info second reminder sent",
    },
    {
      label: "Add Info received",
      value: "Add Info received",
    },
    {
      label: "Add Info incomplete",
      value: "Add Info incomplete",
    },
    {
      label: "Initial review complete",
      value: "Initial review complete",
    },
    {
      label: "Assessor allocated",
      value: "Assessor allocated",
    },
    {
      label: "DE advice requested",
      value: "DE advice requested",
    },
    {
      label: "On hold",
      value: "On hold",
    },
    {
      label: "Presubmission",
      value: "Presubmission",
    },
  ],
  Assessment: [
    {
      label: "Ready for assessment",
      value: "Ready for assessment",
    },
    {
      label: "In progress",
      value: "In progress",
    },
    {
      label: "Add Info required",
      value: "Add Info required",
    },
    {
      label: "Add Info request sent",
      value: "Add Info request sent",
    },
    {
      label: "Add Info received",
      value: "Add Info received",
    },
    {
      label: "On hold",
      value: "On hold",
    },
    {
      label: "Complete",
      value: "Complete",
    },
  ],
  QA: [
    {
      label: "Ready for QA",
      value: "Ready for QA",
    },
    {
      label: "Commenced",
      value: "Commenced",
    },
    {
      label: "Assessor attention required",
      value: "Assessor attention required",
    },
    {
      label: "Finalised",
      value: "Finalised",
    },
  ],
  Finalised: [
    {
      label: "Outcome sent",
      value: "Outcome sent",
    },
    {
      label: "KIMS entry complete",
      value: "KIMS entry complete",
    },
    {
      label: "Application finalised",
      value: "Application finalised",
    },
    {
      label: "Appeal Received",
      value: "Appeal Received",
    },
    {
      label: "Transfer Received",
      value: "Transfer Received",
    },
    {
      label: "Withdrawn",
      value: "Withdrawn",
    },
    {
      label: "Unable to process",
      value: "Unable to process",
    },
    {
      label: "Add Info not received",
      value: "Add Info not received",
    },
  ],
};
